import React, { useState } from "react";

export const LoaderContext = React.createContext();

function LoaderProvider({ children }) {
  const [loader, setLoader] = useState({
    state: false,
  });
  const [showDrawer, setShowDrawer] = useState(
    localStorage.getItem("Collapse") === "true",
  );
  const [activeDoc, setActiveDoc] = useState(null);

  const value = React.useMemo(() => {
    return {
      loader,
      setLoader,
      showDrawer,
      setShowDrawer,
      activeDoc,
      setActiveDoc,
    };
  }, [loader, setLoader, showDrawer, setShowDrawer, activeDoc, setActiveDoc]);

  return (
    <LoaderContext.Provider value={value}>{children}</LoaderContext.Provider>
  );
}

export default LoaderProvider;
